// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2SNH0","header":"PatientBlock_header__3wToz","label":"PatientBlock_label__2mSzz","option":"PatientBlock_option__3ZfgE"};